const mutationTypes = {
  SET_LOADING: 'SET_LOADING',
  SET_CATEGORIES: 'SET_CATEGORIES'
}

const actionTypes = {
  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
}

export {mutationTypes, actionTypes}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolCategoriesTypes.js